import { render, staticRenderFns } from "./PageNum.vue?vue&type=template&id=a2a10ae4&scoped=true&"
import script from "./PageNum.vue?vue&type=script&lang=js&"
export * from "./PageNum.vue?vue&type=script&lang=js&"
import style0 from "./PageNum.vue?vue&type=style&index=0&id=a2a10ae4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a10ae4",
  null
  
)

export default component.exports